import {
  IOfferingChange,
  OfferingSwitcher,
} from 'legacy/lut/components/widgets/public/partner360/offeringsSwithList/OfferingSwitcher'
import { IProgramType } from 'legacy/lut/features/partner360/configuration'
import { useCallback } from 'react'

import { useFormField } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'

import { TRANSLATION_KEYS } from '../../../../../../../../translations'
import { GLOBAL_PARTNER_FORM_KEY } from '../../../../configs'
import { Label } from '../label/Label'

import styles from './OfferingsList.module.scss'

interface IOfferingsProps {
  offerings: IProgramType[]
}

export const OfferingsList = ({ offerings }: IOfferingsProps) => {
  const isLastOffering = useCallback((offerings: IProgramType[], offering: IProgramType) => {
    const enabledOfferings = offerings.filter((el) => el.enabled)
    return (enabledOfferings.length === 1 && offering.enabled) || false
  }, [])

  const checkValidation = useCallback((value: IProgramType[]) => {
    const enabledOfferings = value.filter((el) => el.enabled)
    return !enabledOfferings.length
      ? TRANSLATION_KEYS.globalPartnerForm.formFields.offeringsRequired
      : ''
  }, [])

  const { value, handleChange, validationMessage } = useFormField({
    defaultValue: offerings,
    formKey: GLOBAL_PARTNER_FORM_KEY,
    field: 'offeringsState',
    onValidate: checkValidation,
    validationType: ValidationType.ONCHANGE,
    isRequired: true,
  })

  const onChange = useCallback(
    (changedData: IOfferingChange) => {
      const modifiedOfferings = value.map((offering) =>
        offering.programType === changedData.offering.programType
          ? { ...offering, enabled: changedData.flag }
          : offering
      )
      handleChange(modifiedOfferings)
    },
    [handleChange, value]
  )

  return (
    <div className={styles.root}>
      <Label
        isEmptyValue={!value.length}
        translation={TRANSLATION_KEYS.globalPartnerForm.formFields.offerings}
        validationMessage={validationMessage}
      />

      {value.map((offering, index) => (
        <OfferingSwitcher
          key={index}
          offering={offering}
          index={index}
          availableProgramTypes={offerings}
          onToggle={onChange}
          isToggleDisabled={isLastOffering(value, offering)}
          isTooltipDisabled={!isLastOffering(value, offering)}
        />
      ))}
    </div>
  )
}
